import { render } from "./TraitementConsultation.vue?vue&type=template&id=383a0cbc&scoped=true"
import script from "./TraitementConsultation.vue?vue&type=script&lang=js"
export * from "./TraitementConsultation.vue?vue&type=script&lang=js"

import "./TraitementConsultation.vue?vue&type=style&index=0&id=383a0cbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a0cbc"]])

export default __exports__